import { useMemo } from 'react'

import { GOOGLE_CLIENT_ID } from '../configs/constant'

export function useOauth(referralCode?: string) {
  const link = useMemo(() => {
    const origin = window.location.origin
    const url = new URL('https://accounts.google.com/o/oauth2/auth')
    url.searchParams.set('scope', 'email profile')
    url.searchParams.set('response_type', 'token')
    url.searchParams.set('redirect_uri', `${origin}/auth/callback`)
    url.searchParams.set('include_granted_scopes', 'true')
    url.searchParams.set('client_id', GOOGLE_CLIENT_ID)
    url.searchParams.set('prompt', 'select_account')

    const state: Record<string, string> = {}
    if (referralCode) state.referralCode = referralCode
    if (Object.keys(state).length > 0)
      url.searchParams.set('state', JSON.stringify(state))

    return url.toString()
  }, [referralCode])

  return link
}
